import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col, Button,
} from "reactstrap";

// core components

// index page sections


import {getStats} from "../../components/helpers/StatsHelpers";
import {RiUserFill} from "react-icons/ri";
import {SeoHelper} from "../../components/helpers/SeoHelper";
import InstructionsWizard from "./InstructionsWizard";

class SignInHelp extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);

    // sessionStorage.removeItem("customer");
  }

  stepsData = [
    {
      title: "Step-by-step guide on signing into your account",
      description: "You must have a registered account with The Worship Bible to sign-in.  " +
          "If you need help registering please check out our " +
          "<a href='/help/how-to-register'>How to Register</a> guide." +
          "<br/><br/>" +
          "At the end of this guide you will be able to successfully:" +
          "<br/><br/><img src=\"/help-images/blue-arrow.png\" style=\"width: 40px; height: auto;\">&nbsp;" +
          "sign in to your account",
    },
    {
      title: "Sign in to your account",
      description: "Click the <a href='/sign-in'><b><svg stroke=\"currentColor\" fill=\"currentColor\" stroke-width=\"0\" viewBox=\"0 0 24 24\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z\"></path></svg>Sign In</b></a> button on the navigation bar" +
          "<img src=\"/help-images/sign-in/sign-in-form.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
          "Enter your email address and password and click the <span style='color: #5e72e4'>Sign-In</span> button.<br/> "
    },
    {
      title: "Successfully signed in",
      description: "If you successfully signed in you will see the home page, there is a button with your forename in the top right hand corner, this is <b>Your Account</b> button." +
          "<br/><br/>" +
          "<img src=\"/help-images/sign-in/signed-in-home-page.png\" style=\"width: 100%; height: auto; max-width: 100%;\">"
    },
    {
      title: "What's next",
      description: "You can now access all member features:" +
          "<br/><br/>Clicking on <b>Your Account</b> button will present a menu." +
          "<br/><br/>" +
          "<img src=\"/help-images/sign-in/signed-in-options.png\" style=\"width: 50%; height: auto; max-width: 100%;\">" +
          "<br/></br><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/your-profile'>View your profile</a>" +
          "<br/></br><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/your-profile/saved-song-flows'>View your saved song-flows</a>",
      image: "/help-images/well-done.png",
      enlargeable: false
    }
  ];


  render() {
    return (
      <>
        <SeoHelper
            uri="/help/how-to-sign-in"
            title="Learn how to sign in | Help | The Worship Bible"
            description={"Learn how to sign in"} />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>help</span>
                      </h1>
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-primary rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-check-bold" />*/}
                          {/*</div>*/}
                          <Row className="mt-3">
                            <Col>
                              <div className="d-flex align-items-center mb-3">
                                <RiUserFill color="#5e72e4" size="24" className="mr-2"/>
                                <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">How to sign in</h2>
                              </div>
                            </Col>
                            <Col md="3" xs="12">
                              <Button
                                  block
                                  type="submit"
                                  className="mb-2"
                                  color="white"
                                  href="/help"
                              >
                                <span className="btn-inner--text">Back to help</span>
                              </Button>
                            </Col>
                          </Row>
                          <p className="description mt-3">
                            <InstructionsWizard stepsData={this.stepsData} />
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        
      </>
    );
  }
}

export default SignInHelp;
